import React, { useState, useEffect, useContext } from "react";
import { createParentCompany, updateParentCompany } from "../../../Utility/Api";
import { WarehouseContext } from "../../../Utility/UserContext";
import { setLocalStorage } from "../../../Utility/function";

const ParentCompany = () => {
    const { setParentCompany, UserItem } = useContext(WarehouseContext);
    const [user] = useState(UserItem);
    const [formData, setFormData] = useState({
        parentCompanyName: "",
        parentCompanyRN: "",
        expiryDate: "",
        id: ""
    });
    const [hasParentCompany, setHasParentCompany] = useState(false);

    useEffect(() => {
        if (user?.parent_company?.parent_company_id) {
            setFormData({
                parentCompanyName: user.parent_company.parent_company_name || "",
                parentCompanyRN: user.parent_company.parent_company_rn || "",
                expiryDate: user.parent_company.expiry_date || "",
                id: user.parent_company_id || ""
            });
            setHasParentCompany(true);
        }
    }, [user]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        var payload = {
            parent_company_name: formData.parentCompanyName,
            parent_company_rn: formData.parentCompanyRN,
            expiry_date: formData.expiryDate,
            user_id: user?.user_id
        };

        try {
            const response = await createParentCompany(payload);
            if (response.data) {
                setParentCompany(response.data.data);
                setLocalStorage("ParentCompany", JSON.stringify(response.data.data));
                window.location.href = "/sub-company";
            }
        } catch (error) {
            console.error("Error registering parent company:", error);
        }
    };

    const HandleUpdate = async () => {
        var payload = {
            parent_company_name: formData.parentCompanyName,
            parent_company_rn: formData.parentCompanyRN,
            expiry_date: formData.expiryDate,
            user_id: user?.user_id
        };
        try {
            const response = await updateParentCompany(formData.id, payload);
            if (response.data) {
                setParentCompany(response.data.data);
                setLocalStorage("ParentCompany", JSON.stringify(response.data.data));
                window.location.href = "/sub-company";
            }
        } catch (error) {
            console.error("Error registering parent company:", error);
        }
    }

    return (
        <div className="container d-flex justify-content-center align-items-center min-vh-100">
            <div className="row w-100">
                <div className="col-md-6 mx-auto">
                    <div className="card shadow-lg border-0 rounded-3">
                        <div className="card-body p-4">
                            <h4 className="text-center mb-4 text-primary fw-bold">{hasParentCompany ? "Parent Company" : "Company Registration"}</h4>
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Company Name</label>
                                    <input
                                        type="text"
                                        name="parentCompanyName"
                                        className="form-control rounded shadow-sm"
                                        value={formData.parentCompanyName}
                                        onChange={handleChange}
                                        required
                                        placeholder="Enter Parent Company Name"
                                    // disabled={hasParentCompany}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Company Registration Number</label>
                                    <input
                                        type="text"
                                        name="parentCompanyRN"
                                        className="form-control rounded shadow-sm"
                                        value={formData.parentCompanyRN}
                                        onChange={handleChange}
                                        required
                                        placeholder="Enter Registration Number"
                                    // disabled={hasParentCompany}
                                    />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Expiry Date</label>
                                    <input
                                        type="date"
                                        name="expiryDate"
                                        className="form-control rounded shadow-sm"
                                        value={formData.expiryDate}
                                        onChange={handleChange}
                                        required
                                    // disabled={hasParentCompany}
                                    />
                                </div>
                                {/* {!hasParentCompany ? (
                                    <button type="submit" className="btn btn-primary w-100 rounded shadow-sm fw-bold">
                                        Register
                                    </button>
                                ) : (
                                    <button type="button" className="btn btn-success w-100 rounded shadow-sm fw-bold" onClick={() => window.location.href = "/shops"}>
                                        Continue
                                    </button>
                                )} */}
                                <div className="d-flex column-gap-3">
                                    {hasParentCompany ? (
                                        <>
                                            <button type="button" className="btn btn-primary w-100 rounded shadow-sm fw-bold" onClick={() => HandleUpdate()}>
                                                Update
                                            </button>
                                            <button type="button" className="btn btn-success w-100 rounded shadow-sm fw-bold" onClick={() => window.location.href = "/sub-company"}>
                                                Continue
                                            </button>
                                        </>
                                    ) : (
                                        <button type="submit" className="btn btn-primary w-100 rounded shadow-sm fw-bold">
                                            Register
                                        </button>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ParentCompany;
